import React from 'react';
import PropTypes from 'prop-types';
import { CaseFileCard } from './CaseFileCard';
import { UiMessages } from '../uiMessages';

export function CaseFileGroup({
  title,
  description,
  items,
  isReadOnly,
  canOpenPlayer,
  onDelete,
  onDeleteTranscript,
  onOpenPlayer,
  onBrowseAddTranscript,
  onRemoteTranscriptFileChange,
  setRemoteTranscriptInputRef,
  transcriptAccept,
  isAddingTranscript,
  cardProps
}) {
  return (
    <section className="case-files-group case-files-group-neutral">
      <div className="case-files-group-header">
        <div>
          <h4 className="case-files-group-title">{title}</h4>
          {description ? (
            <p className="case-files-group-description">{description}</p>
          ) : null}
        </div>
        <div className="case-files-group-count">{items.length}</div>
      </div>

      <div className="case-files-group-body">
        {items.length > 0 ? (
          items.map((item, index) => (
            <CaseFileCard
              key={`${item.mediaRecord?.mediaId || item.mediaRecord?.storedFileName || item.mediaRecord?.originalFileName || 'case-file'}-${index}`}
              item={item}
              isReadOnly={isReadOnly}
              canOpenPlayer={canOpenPlayer}
              onDelete={onDelete}
              onDeleteTranscript={onDeleteTranscript}
              onOpenPlayer={onOpenPlayer}
              onBrowseAddTranscript={onBrowseAddTranscript}
              onRemoteTranscriptFileChange={onRemoteTranscriptFileChange}
              setRemoteTranscriptInputRef={setRemoteTranscriptInputRef}
              transcriptAccept={transcriptAccept}
              isAddingTranscript={typeof isAddingTranscript === 'function' ? isAddingTranscript(item) : false}
              {...cardProps}
            />
          ))
        ) : (
          <div className="case-files-empty">{UiMessages.noFilesYet}</div>
        )}
      </div>
    </section>
  );
}

CaseFileGroup.propTypes = {
  title: PropTypes.node,
  description: PropTypes.node,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  isReadOnly: PropTypes.bool,
  canOpenPlayer: PropTypes.bool,
  onDelete: PropTypes.func,
  onDeleteTranscript: PropTypes.func,
  onOpenPlayer: PropTypes.func,
  onBrowseAddTranscript: PropTypes.func,
  onRemoteTranscriptFileChange: PropTypes.func,
  setRemoteTranscriptInputRef: PropTypes.func,
  transcriptAccept: PropTypes.string,
  isAddingTranscript: PropTypes.func,
  cardProps: PropTypes.object
};
